import { useState } from "react";
import { useOnClickOutside } from "usehooks-ts";
import { useFloating, autoUpdate, offset, shift, FloatingFocusManager } from "@floating-ui/react";
import styles from "./edit-task-modal.module.css";

const Arrow = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="9" height="6" viewBox="0 0 9 6" fill="none">
    <path d="M8.11442 1L4.55713 4.55729" stroke="#1E1E1E" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M1 1L4.55729 4.55729" stroke="#1E1E1E" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export function EditTaskModalDropdown({
  icon,
  title,
  children,
}: {
  icon: React.ReactNode;
  title: string;
  children?: React.ReactNode | ((onDismiss: () => void) => React.ReactNode);
}) {
  const [open, setOpen] = useState(false);
  const { refs, floatingStyles, context } = useFloating({
    open,
    placement: "bottom-start",
    middleware: [offset(4), shift({ padding: 5 })],
    whileElementsMounted: autoUpdate,
  });

  const onDismiss = () => setOpen(false);

  useOnClickOutside(
    refs.floating,
    (event) => {
      // Don't close if clicking on the toggle button
      const target = event.target as Node;
      const toggleButton = refs.reference.current;

      if (toggleButton && "contains" in toggleButton && toggleButton.contains(target)) {
        return;
      }

      onDismiss();
    },
    "mouseup"
  );

  return (
    <>
      <div
        ref={refs.setReference}
        className={styles.sidebarDropdown}
        onClick={(e) => {
          e.stopPropagation();
          setOpen((previous) => !previous);
        }}
      >
        {icon}
        <span className={styles.dropdownTitle}>{title}</span>
        <div className={styles.dropdownArrow}>
          <Arrow />
        </div>
      </div>
      {open && (
        <FloatingFocusManager context={context} modal={false}>
          <div ref={refs.setFloating} style={floatingStyles} className={styles.dropdownContent}>
            {typeof children === "function" ? children(onDismiss) : children}
          </div>
        </FloatingFocusManager>
      )}
    </>
  );
}
